export default function initSearch(){
    $('#mobile-search-icon').on('click', function () {
		$('#mobile-search').slideToggle();
	});
}